module.exports = __webpack_public_path__ + "media/images/sale_crm/projects-def0fa7b65d70fea1f8dc7b1e1417f55.svg";